/* eslint-disable prettier/prettier */
import React, { useEffect, useState, useLayoutEffect } from 'react';
import TablaReporteGeneral from '../Components/Organisms/TablaReporteGeneral';
import {
  ArrowLeftOutlined,
  BankOutlined,
  PaperClipOutlined,
  RiseOutlined,
  FallOutlined,
  DownOutlined,
  FileTextOutlined,
  BookOutlined,
  FileExcelOutlined,
  SearchOutlined
} from '@ant-design/icons';
import clienteAxios from '../Utils/clienteAxios';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { useNavigate } from 'react-router-dom';
import { InputNumber, Input, Upload, Dropdown, Form } from 'antd';
import Boton from '../Components/Atoms/Boton';
import Esqueleto from '../Components/Atoms/Esqueleto';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import currencyFormatter from '../../src/Utils/currencyFormatter';
import decodeToken from '../Utils/decodeToken';
import { isWorkflowRole } from '../Utils/workflowRole';
import Modal from '../Components/Atoms/Modal';
import moment from 'moment';
import 'moment/locale/es';
import PropTypes from 'prop-types';

const mayuscula = (texto) => texto.charAt(0).toUpperCase() + texto.slice(1);

// Variación o diferencia con su signo escrito: el color solo refuerza si el cambio es favorable.
const Cambio = ({ valor, buenoSiSube, texto }) => {
  if (!valor) return <span className="reporte-neutro">Sin cambios</span>;
  const favorable = buenoSiSube ? valor > 0 : valor < 0;
  const Icono = valor > 0 ? RiseOutlined : FallOutlined;
  return (
    <span className={favorable ? 'reporte-favorable' : 'reporte-desfavorable'}>
      <Icono aria-hidden="true" /> {valor > 0 ? '+' : '-'}
      {texto}
    </span>
  );
};
Cambio.propTypes = {
  valor: PropTypes.number,
  buenoSiSube: PropTypes.bool,
  texto: PropTypes.string
};

const ReporteGeneral = () => {
  const [requestsPurchase, setRequestsPurchase] = useState([]);
  const [budget, setBudget] = useState(0);
  const [spent, setSpent] = useState(0);
  const [previousBudget, setPreviousBudget] = useState(0);
  const [previousSpent, setPreviousSpent] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isModalOpenIncome, setIsModalOpenIncome] = useState(false);
  const [isModalOpenEgress, setIsModalOpenEgress] = useState(false);
  const [budgetAmount, setBudgetAmount] = useState(0);
  const [archive, setArchive] = useState(null);
  const [isFileRemoved, setIsFileRemoved] = useState(false);
  const [nameReturn, setNameReturn] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [reloadEgress, setReloadEgress] = useState(false);
  const [reloadTable, setReloadTable] = useState(true);
  const [currentMonth, setCurrentMonth] = useState('');
  const [previousMonth, setPreviousMonth] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const navigate = useNavigate();
  let decodedToken = decodeToken(localStorage.getItem('token'));

  // Obtener nombres de meses
  useEffect(() => {
    setCurrentMonth(mayuscula(moment().locale('es').format('MMMM YYYY')));
    setPreviousMonth(mayuscula(moment().subtract(1, 'month').locale('es').format('MMMM YYYY')));
  }, []);

  const showModalIncome = () => {
    setIsModalOpenIncome(!isModalOpenIncome);
  };

  const showModalEgress = () => {
    setIsModalOpenEgress(!isModalOpenEgress);
  };

  useLayoutEffect(() => {
    const table = document.querySelector('.ant-table-content table');
    if (table) {
      table.id = 'table-to-xls';
    }
  }, []);

  useEffect(() => {
    clienteAxios
      .get(`/caja-chica/administrador/solicitudes-de-compra/ver`)
      .then((response) => {
        let data = response.data.spents;
        data.reverse();
        setRequestsPurchase(data);
        setReloadTable(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [reloadTable]);

  useEffect(() => {
    clienteAxios
      .get(`/caja-chica/information/estimate`)
      .then((response) => {
        let data = response.data;
        setBudget(parseFloat(data.AvailableBudget) || 0);
        setSpent(parseFloat(data.MonthlyExpenses) || 0);
        setPreviousBudget(parseFloat(data.PreviousAvailableBudget) || 0);
        setPreviousSpent(parseFloat(data.PreviousMonthlyExpenses) || 0);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [loading]);

  // Calcular porcentaje de cambio
  const calculateChangePercentage = (current, previous) => {
    if (previous === 0) return 0;
    return ((current - previous) / previous) * 100;
  };

  const budgetChange = calculateChangePercentage(budget, previousBudget);
  const spentChange = calculateChangePercentage(spent, previousSpent);

  const puedeAdministrar =
    decodedToken?.role?.name === 'administrator' ||
    decodedToken?.role?.name === 'Adquisiciones' ||
    decodedToken?.role?.name === 'Super_Admin' ||
    decodedToken?.role?.name === 'caja_chica' ||
    isWorkflowRole(decodedToken?.role?.name);

  const solicitudesVisibles = requestsPurchase.filter((item) => {
    const texto = busqueda.trim().toLowerCase();
    if (!texto) return true;
    return [
      `gto-${item?.id}`,
      item?.user_name,
      item?.spent?.[0]?.spent_name,
      item?.center?.[0]?.center_name,
      item?.company?.[0]?.company_name,
      item?.department_name
    ].some((campo) => (campo || '').toString().toLowerCase().includes(texto));
  });

  const handleOk = async () => {
    try {
      if (budgetAmount <= 0) {
        Swal.fire({
          icon: 'error',
          title: '¡Cuidado!',
          confirmButtonText: 'INTENTAR DE NUEVO',
          text: 'No puedes ingresar un monto de $0!'
        });
        return;
      }
      setIsSubmitting(true);
      const result = await Swal.fire({
        title: `${currencyFormatter(budgetAmount)}`,
        text: '¿Estás seguro de ingresar este monto?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      });
      if (result.isConfirmed) {
        await clienteAxios.post(`/caja-chica/estimate`, { total: budgetAmount });
        showModalIncome();
        Swal.fire({
          icon: 'success',
          title: 'Presupuesto ingresado correctamente!',
          showCancelButton: false,
          confirmButtonText: 'LISTO'
        }).then(() => {
          setBudgetAmount(0);
          setLoading(true);
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '¡Error!',
        text: 'No se pudo ingresar el monto'
      });
    } finally {
      setBudgetAmount(0);
      setIsSubmitting(false);
    }
  };

  const handleReturnMoney = async () => {
    try {
      const result = await Swal.fire({
        title: 'Cuidado',
        text: '¿Estás seguro de egresar este monto?',
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      });
      if (result.isConfirmed) {
        const data = new FormData();
        data.append('total_returned', budget);
        data.append('was_returned_to', nameReturn);
        if (!isFileRemoved) {
          data.append('file', archive);
        }
        await clienteAxios.post(`/caja-chica/estimate/return`, data);
        showModalEgress();
        setLoading(true);
        setArchive(null);
        setNameReturn('');
        setReloadEgress(!reloadEgress);
        Swal.fire({
          icon: 'success',
          title: 'Presupuesto egresado correctamente!',
          showCancelButton: false,
          confirmButtonText: 'LISTO'
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        text: error.response.data.message,
        confirmButtonText: 'INTENTAR DE NUEVO'
      });
    } finally {
      setReloadEgress(!reloadEgress);
      setIsSubmitting(false);
      setArchive(null);
      setNameReturn('');
    }
  };

  const historiales = [
    {
      key: '1',
      icon: <FileTextOutlined />,
      label: <Link to="/historial-egreso-efectivo">Historial egreso</Link>
    },
    {
      key: '2',
      icon: <BankOutlined />,
      label: <Link to="/historial-empresas">Empresa eventuales</Link>
    },
    {
      key: '3',
      icon: <BookOutlined />,
      label: <Link to="/historial-conceptos">Conceptos</Link>
    }
  ];

  const celda = (contenido, ancho = 90) =>
    loading ? <Esqueleto ancho={ancho} alto={16} /> : contenido;
  const eficiencia = previousBudget !== 0 ? ((budget / previousBudget) * 100).toFixed(2) : 0;

  return (
    <>
      <div className="detalle-encabezado reporte-encabezado">
        <button
          type="button"
          className="detalle-volver"
          aria-label="Volver"
          onClick={() => navigate(-1)}>
          <ArrowLeftOutlined aria-hidden="true" />
        </button>
        <h1 className="detalle-titulo reporte-titulo">Reporte general</h1>
        {puedeAdministrar ? (
          <div className="reporte-acciones">
            <Boton type="secondary" icon={<FallOutlined />} onClick={showModalEgress}>
              Egresar presupuesto
            </Boton>
            <Boton type="primary" icon={<RiseOutlined />} onClick={showModalIncome}>
              Ingresar presupuesto
            </Boton>
            <Dropdown menu={{ items: historiales }} trigger={['click']} placement="bottomRight">
              <Boton type="secondary">
                Historiales
                <DownOutlined />
              </Boton>
            </Dropdown>
          </div>
        ) : null}
      </div>

      <section className="reporte-comparativa" aria-label="Comparativa con el mes anterior">
        <div className="reporte-comparativa__envoltura" aria-busy={loading}>
          <table className="reporte-comparativa__tabla">
            <thead>
              <tr>
                <th scope="col">
                  <span className="sr-only">Concepto</span>
                </th>
                <th scope="col">{currentMonth}</th>
                <th scope="col">{previousMonth}</th>
                <th scope="col">Diferencia</th>
                <th scope="col">Variación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <Link to="/historial-ingresado">Presupuesto disponible</Link>
                </th>
                <td className={`reporte-cifra reporte-cifra--grande${budget < 0 ? ' is-negativa' : ''}`}>
                  {celda(currencyFormatter(budget), 110)}
                </td>
                <td className="reporte-cifra">{celda(currencyFormatter(previousBudget))}</td>
                <td className="reporte-cifra">
                  {celda(
                    <Cambio
                      valor={budget - previousBudget}
                      buenoSiSube
                      texto={currencyFormatter(Math.abs(budget - previousBudget))}
                    />,
                    100
                  )}
                </td>
                <td>
                  {celda(
                    <Cambio
                      valor={budgetChange}
                      buenoSiSube
                      texto={`${Math.abs(budgetChange).toFixed(2)} %`}
                    />,
                    70
                  )}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <Link to="/historial-gastado">Presupuesto gastado</Link>
                </th>
                <td className="reporte-cifra reporte-cifra--grande">
                  {celda(currencyFormatter(spent), 110)}
                </td>
                <td className="reporte-cifra">{celda(currencyFormatter(previousSpent))}</td>
                <td className="reporte-cifra">
                  {celda(
                    <Cambio
                      valor={spent - previousSpent}
                      buenoSiSube={false}
                      texto={currencyFormatter(Math.abs(spent - previousSpent))}
                    />,
                    100
                  )}
                </td>
                <td>
                  {celda(
                    <Cambio
                      valor={spentChange}
                      buenoSiSube={false}
                      texto={`${Math.abs(spentChange).toFixed(2)} %`}
                    />,
                    70
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="reporte-eficiencia">
          Eficiencia presupuestal:{' '}
          <strong>{loading ? <Esqueleto ancho={60} alto={14} className="reporte-en-linea" /> : `${eficiencia} %`}</strong>
        </p>
      </section>

      <div className="reporte-herramientas">
        <Input
          allowClear
          className="reporte-buscar"
          prefix={<SearchOutlined aria-hidden="true" />}
          placeholder="Buscar por solicitud, solicitante, concepto o centro"
          aria-label="Buscar solicitudes"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
        <ReactHtmlTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button"
          table="table-to-xls"
          filename="Reporte General"
          sheet="Reporte General"
          buttonText={
            <>
              <FileExcelOutlined className="mr-2" />
              Exportar en Excel
            </>
          }
        />
      </div>

      <div className="flex-row flex-wrap">
        <TablaReporteGeneral
          data={solicitudesVisibles}
          setReloadTable={setReloadTable}
          reloadTable={reloadTable}
        />
      </div>

      <Modal
        title="INGRESAR PRESUPUESTO"
        centered
        open={isModalOpenIncome}
        onCancel={showModalIncome}
        onOk={handleOk}
        width={350}
        confirmLoading={isSubmitting}>
        <Form>
          <Form.Item label="Importe">
            <InputNumber
              formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              value={budgetAmount}
              onChange={(value) => setBudgetAmount(value)}
              className="width-100"
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="EGRESAR PRESUPUESTO"
        centered
        open={isModalOpenEgress}
        onCancel={showModalEgress}
        onOk={handleReturnMoney}
        confirmLoading={isSubmitting}
        key={reloadEgress}
        okText="Aceptar"
        cancelText="Cancelar">
        <Form
          labelCol={{
            span: 6
          }}
          labelAlign="left"
          wrapperCol={{
            span: 19
          }}>
          <Form.Item label="Monto">
            <Input
              value={currencyFormatter(budget)}
              defaultValue={budget}
              disabled
            />
          </Form.Item>
          <Form.Item label="Destinatario">
            <Input onChange={(e) => setNameReturn(e.target.value)} value={nameReturn} />
          </Form.Item>
          <Form.Item label="Archivo">
            <Upload
              maxCount={1}
              listType="picture"
              accept=".pdf, .jpg, .png, .jpeg, .doc, .docx, .xls, .xlsx"
              beforeUpload={(file) => {
                setArchive(file);
                setIsFileRemoved(false);
                return false;
              }}
              onRemove={() => {
                setArchive(null);
                setIsFileRemoved(true);
              }}
              multiple={false}>
              <Boton type="secondary" icon={<PaperClipOutlined />}>
                Adjuntar archivo o imagen
              </Boton>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ReporteGeneral;